import { object, string as yupString } from "yup";
import { mixed } from "yup";

// @todo: Have type guard that can provide union
let documentReferenceOrString = mixed(
  (input) => input instanceof String || input instanceof {}
).transform((value, originalValue, context) => {
  // firebase date object requires toDate to be called
  // to convert it to a valid date object
  value = originalValue?._key?.path.toString();

  // if it's valid return the key otherwise return empty string
  return value || "";
});

export const actionSchema = object({
  actionFor: mixed(),
  origin: yupString(),
  completedBy: mixed(),
  state: yupString().default("actionRequired"),
  note: yupString().default(""),
});
